import Rails from 'rails-ujs';
import { showToast } from './helpers/toastr';

export default function initPlaylists() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-playlist-toggle-btn');
    if (!btn) return;

    const card = btn.closest('.c-playlist-card');
    if (!card) return;

    const checkbox = card.querySelector('.js-playlist-checkbox');
    if (!checkbox) return;

    // Toggle checkbox state manually
    checkbox.checked = !checkbox.checked;

    // Store state on form to rollback on error
    const form = btn.closest('form.js-auto-submit-playlist-form');
    if (form) {
      // Toggle button classes manually (optimistic UI)
      if (checkbox.checked) {
        btn.classList.remove('btn-outline-add');
        btn.classList.add('btn-outline-added');
      } else {
        btn.classList.remove('btn-outline-added');
        btn.classList.add('btn-outline-add');
      }

      form.dataset.triggeringBtn = btn.id || (btn.id = `btn-${Date.now()}`);
      form.dataset.targetCheckbox = checkbox.id || (checkbox.id = `chk-${Date.now()}`);
      form.dataset.wasChecked = checkbox.checked;

      Rails.fire(form, 'submit');
    }
  });

  document.addEventListener('ajax:success', (e) => {
    const form = e.target.closest('form.js-auto-submit-playlist-form');
    if (!form) return;

    const wasChecked = form.dataset.wasChecked === 'true';
    if (wasChecked) {
      showToast('success', 'Added to playlist successfully');
    } else {
      showToast('success', 'Removed from playlist successfully');
    }
  });

  document.addEventListener('ajax:error', (e) => {
    const form = e.target.closest('form.js-auto-submit-playlist-form');
    if (!form) return;

    showToast('error', 'Oops! Something went wrong. Please try again later.');

    const btn = document.getElementById(form.dataset.triggeringBtn);
    const checkbox = document.getElementById(form.dataset.targetCheckbox);

    if (btn && checkbox) {
      checkbox.checked = !checkbox.checked;
      if (checkbox.checked) {
        btn.classList.remove('btn-outline-add');
        btn.classList.add('btn-outline-added');
      } else {
        btn.classList.remove('btn-outline-added');
        btn.classList.add('btn-outline-add');
      }
    }
  });

  // Intercept clicks on the playlist ellipsis in the capturing phase to prevent video playback
  document.addEventListener(
    'click',
    (e) => {
      const ellipsis = e.target.closest('.icon-new-ellipsis');
      if (!ellipsis) return;

      e.stopPropagation();
      e.preventDefault();

      const lessonItem = ellipsis.closest('.modal-lessons-item');
      if (!lessonItem) return;

      const dropdown = lessonItem.querySelector('.modal-lessons-item-dropdown');
      if (!dropdown) return;

      // Close all other dropdowns
      document.querySelectorAll('.modal-lessons-item-dropdown.show').forEach((menu) => {
        if (menu !== dropdown) {
          menu.classList.remove('show');
        }
      });

      dropdown.classList.toggle('show');
    },
    true,
  );

  // Close dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    const dropdownClick = e.target.closest('.modal-lessons-item-dropdown');
    if (dropdownClick) return; // Allow dropdown links and items to be clicked normally

    document.querySelectorAll('.modal-lessons-item-dropdown.show').forEach((menu) => {
      menu.classList.remove('show');
    });
  });
}
